"use strict";
// packages/contracts/src/monitoramento.ts — Fase 03, Plano 06 (MON-01, MON-02, MON-03).
// Contratos de monitoramento em tempo real (SSE), Visão Geral e Registro de Consumo/Progresso.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=monitoramento.js.map